export class OrderTrackingEntry {
  public ts: string;
  public transactionId: string;
  public eventType: string;
  public eventData: any[];
}
